import { Component, Input } from '@angular/core';
import { Projection } from '../models';
import { FormatDatePipe } from 'src/app/miscellaneous/pipes/format-date.pipe';
import { Store } from '@ngrx/store';
import { selectBooking } from '../../pickup-declarations/state/actions';
import { NavigationService } from 'src/app/services/navigation.service';

@Component({
  selector: 'app-bobby-calves-approved-declaration-card',
  templateUrl: './bobby-calves-approved-declaration-card.component.html',
  styleUrls: ['./bobby-calves-approved-declaration-card.component.scss'],
})
export class BobbyCalvesApprovedDeclarationCardComponent {
  @Input() pickup: Projection.Pickup;

  constructor(
    private readonly store: Store,
    private readonly dateFormatter: FormatDatePipe,
    private readonly navigationService: NavigationService,
  ) {}

  public get date(): string {
    return this.dateFormatter.transform(this.pickup.date, 'dwdm');
  }

  public fillOutDeclaration(): void {
    this.store.dispatch(selectBooking({
      propertyId: this.pickup.anzcoPropertyId,
      bookingId: this.pickup.booking.id,
    }));
    this.navigationService.pickupDeclarations();
  }
}
